<template lang="pug">
router-view
</template>
<script>
export default {
    name: 'Laudos',
    data() {
        return {};
    }
};
</script>

<style lang="scss">
#laudos {
    height: 100%;
    width: 100%;
}

.grid-display-laudos-dashboard {
    display: grid;
    grid-template-columns: 25% 74.2%;
    grid-template-rows: 1fr;
    grid-column-gap: 15px;
    grid-row-gap: 0px;
    height: 650px;
    transition: 0.6s;
    width: 100%;
}
.grid-bloco1 {
    grid-area: 1 / 1 / 2 / 2;
    position: relative;
    min-height: 650px;
    max-height: 650px;
}

.grid-bloco2 {
    grid-area: 1 / 2 / 2 / 3;
    min-height: 650px;
    max-height: 650px;
}

.card-totalizadores-dashboard-laudos__grafico__tabela {
    background: white;
    min-height: 600px;
    max-height: 600px;
    width: 100%;
    border-radius: 5px;
    box-shadow: 0 1px 3px 0 var(--block-shadow);
    overflow: hidden;

    .card-totalizadores-dashboard-laudos__grafico__tabela--grafico {
        height: 520px;
        overflow: hidden;
    }

    .card-totalizadores-dashboard-laudos__grafico__tabela--tabela {
        height: 520px;
        overflow-y: auto;
    }

    .card-totalizadores-dashboard-laudos__grafico__tabela--footer {
        height: 70px;
        border-top: solid 2px #e0e0e0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.card-totalizadores-dashboard-laudos__cards__skeleton {
    height: 90px;
    width: 100%;
    border-radius: 5px;
}

.card-totalizadores-dashboard-laudos__grafico__tabela--skeleton {
    height: 100%;
    width: 100%;
    border-radius: 5px;
}

.titulo-filtro-laudos {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: var(--primary);
    font-weight: 600;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: left;
    i {
        margin-right: 10px;
        font-size: 18px;
        &::before {
            color: var(--primary);
            font-weight: 600;
        }
    }
}
.titulo-filtro-laudos ~ .el-collapse-item__arrow {
    font-size: 18px;

    &::before {
        font-weight: 600;
        color: #434343;
    }
}

.lista-laudos {
    background: var(--white);
    border-radius: 4px;
    overflow: hidden;
}
.titulo-tela {
    margin-bottom: 12px;
}
$attenttion-50: #fdf7e8;
$attenttion-100: #f9e5b9;
$attenttion-500: #edab1d;

$status-50: #eceff1;
$status-100: #cfd8dc;
$status-500: #607d8b;

$tertiary-50: #ebf4eb;
$tertiary-100: #c0ddc1;
$tertiary-500: #359138;

$error-50: #fcebea;
$error-100: #f4c1be;
$error-500: #dc362e;

$grey-100: #f5f5f5;
$grey-300: #e0e0e0;
$grey-600: #757575;

.em-processamento {
    background-color: $attenttion-50;
    border: 1px solid $attenttion-100;
    color: $attenttion-500;
}

.na-fila {
    background-color: $status-50;
    border: 1px solid $status-100;
    color: $status-500;
}

.processado {
    background-color: $tertiary-50;
    border: 1px solid $tertiary-100;
    color: $tertiary-500;
}

.falha-processamento {
    background-color: $error-50;
    border: 1px solid $error-100;
    color: $error-500;
}

.cancelado {
    background-color: $grey-100;
    border: 1px solid $grey-300;
    color: $grey-600;
}
.situacao {
    max-width: 150px;
}
</style>
